import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { ReportRecord } from '../../models/report.model';
import { EditableFieldsService } from '../editable-fields.service';

import { ActionsToolbarComponent } from '../presentation-view/actions-toolbar/actions-toolbar.component';
import { TableInfoComponent } from './table-info/table-info.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-table-view',
  templateUrl: './table-view.component.html',
  styleUrl: './table-view.component.scss',
  providers: [EditableFieldsService],
  imports: [ActionsToolbarComponent, TableInfoComponent],
})
export class TableViewComponent extends AbstractDynamicReportViewComponent {
  readonly removeRecord = output<ReportRecord>();
  readonly reportReordered = output<ReportRecord[]>();

  removeRecordFromReport(reportItem) {
    const recordId = reportItem.recordId ? reportItem.recordId : reportItem.data.recordId;
    this.removeRecord.emit({ ...reportItem, recordId });
  }
}
